import { render, staticRenderFns } from "./projectResultInfo.vue?vue&type=template&id=024b2660&scoped=true"
import script from "./projectResultInfo.vue?vue&type=script&lang=js"
export * from "./projectResultInfo.vue?vue&type=script&lang=js"
import style0 from "./projectResultInfo.vue?vue&type=style&index=0&id=024b2660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b2660",
  null
  
)

export default component.exports